/*!

=========================================================
* Paper Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Row, Container } from "reactstrap";

function DemoFooter() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
        <div className="credits ml-auto">
          <div >
                  <img className="logo-footer" alt="..." src={require("assets/img/flexplay_logo_bnw.png")} />
            </div>
          </div>
          <nav className="footer-nav">
            <ul>
              <li>
             {/*    <a
                  href="https://www.creative-tim.com?ref=pkr-footer"
                  target="_blank"
                >
                  Thanks to Creative Tim
                </a> */}
                <a>info@flexplay.club</a>
              </li>
              <li>
                <a href="/privacy_policy.html" target="_blank" rel="noopener noreferrer">
                  Gizlilik Politikası
                </a>
              </li>

            </ul>
          </nav>
         
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;
